"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eighteen/section/workSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type WorkSection366sItem = {
    key: Key | null | undefined;
    /** Detected variants: "work-item-eighteen one" | "work-item-eighteen two" | "work-item-eighteen three" | "work-item-eighteen four" */
    className: string;
    /** Detected variants: "01" | "02" | "03" | "04" */
    h30Text: ReactNode;
    /** Detected variants: "Day 1" | "Week 1" | "Weeks 2-8" | "Complete" */
    span0Text: ReactNode;
    /** Detected variants: "Schedule Your Consultation" | "Personalized Treatment Plan" | "Active Rehabilitation" | "Return to Full Activity" */
    h30H30Text: ReactNode;
    /** Detected variants: "Book a free phone consultation or initial appointment online. We offer same-day appointments and flexible scheduling." | "Receive a customized recovery program tailored to your goals, with clear outcomes. We explain every step of journey." | "Attend regular therapy sessions with treatment, therapeutic exercises, and education. We progressively program as you improve." | "Graduate from therapy with the strength, mobility, and active lifestyle. We provide maintenance guidance for long-term success." */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-3 col-lg-6 col-sm-6" */
    divClassName?: string;
    /** Detected variants: "work-day" */
    div0ClassName?: string;
    /** Detected variants: "count" */
    h30ClassName?: string;
    /** Detected variants: "day" */
    span0ClassName?: string;
    /** Detected variants: "work-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName2?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "shadow" */
    alt?: string;
    /** Detected variants: "img-fluid shadow-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "/Templates/Doccure/img/bg/shadow-7.png" */
    src?: string;
};
export type HomeEighteenWorkSectionGeneratedProps = {
    divDiv0Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: WorkSection366sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: WorkSection366sItem) => Partial<ComponentProps<"h3">>);
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WorkSection366sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "HOW IT WORKS" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Your Path to Recovery" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "1s" */
    sectionDiv0Div1DivDataWowDuration?: string;
    sectionDiv0Div1ClassName?: string;
    workSection366s: WorkSection366sItem[];
    workSection366sItemWrapper?: (item: WorkSection366sItem, content: ReactNode) => ReactNode;
    workSection366sRenderer?: (defaultNode: ReactNode) => ReactNode;
    workSection366sImageVisible?: boolean;
    workSection366sImageRenderer?: (item: WorkSection366sItem, defaultNode: ReactNode) => ReactNode;
    workSection366sH3Visible?: boolean;
    workSection366sH3Renderer?: (item: WorkSection366sItem, defaultNode: ReactNode) => ReactNode;
    workSection366sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WorkSection366sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    workSection366sH3Props?: Partial<ComponentProps<"h3">> | ((item: WorkSection366sItem) => Partial<ComponentProps<"h3">>);
};

const HomeEighteenWorkSectionGenerated: FC<HomeEighteenWorkSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "HOW IT WORKS",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Your Path to Recovery",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div1DivDataWowDuration = "1s",
    sectionDiv0Div1ClassName,
    divDiv0Div0H30H3Props,
    divDiv0Div1H30H3Props,
    divDiv0ImageWithBasePath0ImageProps,
    workSection366s,
    workSection366sItemWrapper,
    workSection366sRenderer,
    workSection366sImageVisible,
    workSection366sImageRenderer,
    workSection366sH3Visible,
    workSection366sH3Renderer,
    workSection366sImageProps,
    workSection366sH3Props,
}) => {
    return (
        <section className="section work-section-eighteen">
            <div className="container">
                <div className="section-header-eighteen wow fadeInDown" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row row-gap-4 work-row wow fadeInUp"} data-wow-duration={sectionDiv0Div1DivDataWowDuration}>
                    {renderCollectionNode(
                        workSection366s,
                        (item: WorkSection366sItem) => (
                            <div className={item.divClassName ?? "col-xl-3 col-lg-6 col-sm-6"} key={item.key}>
                                <div className={item.className}>
                                    <div className={item.div0ClassName ?? "work-day"}>
                                        {renderItemNode(workSection366sH3Visible, workSection366sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "count"} {...(typeof workSection366sH3Props === "function" ? workSection366sH3Props(item) : (workSection366sH3Props ?? {}))} {...(typeof divDiv0Div0H30H3Props === "function" ? divDiv0Div0H30H3Props(item) : (divDiv0Div0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <span className={item.span0ClassName ?? "day"}>{item.span0Text}</span>
                                    </div>
                                    <div className={item.div1ClassName ?? "work-content"}>
                                        {renderItemNode(workSection366sH3Visible, workSection366sH3Renderer, item, (
                                            <h3 className={item.h30ClassName2 ?? "custom-title"} {...(typeof workSection366sH3Props === "function" ? workSection366sH3Props(item) : (workSection366sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>{item.h30H30Text}</h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                    </div>
                                    {renderItemNode(workSection366sImageVisible, workSection366sImageRenderer, item, (
                                        <SmartImage src={item.src ?? "/Templates/Doccure/img/bg/shadow-7.png"} alt={item.alt ?? "shadow"} className={item.imageWithBasePath0ClassName ?? "img-fluid shadow-1"} {...(typeof workSection366sImageProps === "function" ? workSection366sImageProps(item) : (workSection366sImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                    ))}
                                </div>
                            </div>
                        ),
                        workSection366sItemWrapper,
                        workSection366sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeEighteenWorkSectionGenerated;
